var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-badge',{attrs:{"variant":_vm.$store.getters['form/status2variant'](_vm.model.status)}},[_vm._v("\n        "+_vm._s(_vm.trans.labels[
        'forms.status.' + _vm.model.status
        ])+"\n    ")]),_vm._v(" "),_c('b-badge',{attrs:{"variant":_vm.$store.getters['form/is_public2variant'](_vm.model.is_public)}},[_vm._v("\n        "+_vm._s(_vm.trans.labels[
        'forms.is_public.' + _vm.model.is_public
        ])+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }